module.exports = __webpack_public_path__ + "img/products_icon.c24ff4d3.svg";